import React from 'react';
import { Grid, Typography } from '@material-ui/core';
import { Alert, AlertTitle } from '@material-ui/lab';
import { FieldProps } from '@rjsf/core';
import { useField } from 'formik';
import InstrumentResult from 'modules/InstrumentsQualityControl/features/instruments/components/InstrumentResult';

export default ({ schema, formData, value, id: _id, uiSchema = {}, idSchema }: FieldProps) => {
  const id = _id || idSchema.$id;
  const fieldId = `review.${id}`;
  const [field] = useField(fieldId);

  const showComment = field.value;

  const { format } = uiSchema;

  const result = (
    <>
      <Grid item xs={12}>
        <Typography variant="body1">{schema.title}</Typography>
        {format ? format(value) : <InstrumentResult value={formData || value} />}
      </Grid>
    </>
  );

  if (showComment) {
    return (
      <Alert
        severity="warning"
        style={{
          opacity: 1,
        }}
      >
        {result}
        <AlertTitle>{field.value}</AlertTitle>
      </Alert>
    );
  }

  return result;
};
